import React, { createContext, useContext } from "react";
import PropTypes from "prop-types";

const StateContext = createContext();

export const useStateContext = () => useContext(StateContext);

export const StateContextProvider = ({ children, entered, onEnteredChange, watching, onWatchingChange }) => {
  return (
    <StateContext.Provider value={{ entered, watching, onEnteredChange, onWatchingChange }}>
      {children}
    </StateContext.Provider>
  );
};

StateContextProvider.propTypes = {
  children: PropTypes.node,
  entered: PropTypes.bool,
  watching: PropTypes.bool,
  onEnteredChange: PropTypes.func,
  onWatchingChange: PropTypes.func
};
